<header class="topbar-shell">
  <label class="topbar-search" [attr.aria-label]="'layout.topbar.searchPlaceholder' | t">
    <lucide-icon name="search" [size]="14" class="search-icon"></lucide-icon>
    <input type="search" [placeholder]="'layout.topbar.searchPlaceholder' | t" />
    <span class="search-kbd" aria-hidden="true">⌘K</span>
  </label>

  <div class="topbar-actions">
    <app-trial-badge></app-trial-badge>

    <button
      type="button"
      class="icon-button"
      (click)="toggleTheme()"
      [attr.title]="'layout.topbar.toggleTheme' | t"
    >
      <lucide-icon [name]="theme() === 'dark' ? 'sun' : 'moon'" [size]="14" class="control-icon"></lucide-icon>
    </button>

    <button
      type="button"
      class="icon-button"
      (click)="toggleFeedback($event)"
      [attr.title]="'platformFeedback.fabTooltip' | t"
      [attr.aria-label]="'platformFeedback.fabAria' | t"
    >
      <lucide-icon [img]="feedbackIconImg" name="message-square-plus" [size]="14" class="control-icon"></lucide-icon>
    </button>

    <div class="notifications-wrap">
      <button
        type="button"
        class="icon-button notifications-button"
        (click)="toggleNotifications($event)"
        [attr.title]="'layout.topbar.notifications' | t"
        [attr.aria-expanded]="isNotificationsOpen()"
        aria-haspopup="true"
      >
        <lucide-icon name="bell" [size]="14" class="control-icon"></lucide-icon>
        @if (notificationsStore.hasUnread()) {
          <span class="notifications-badge" aria-hidden="true">
            {{ notificationsStore.unreadCount() > 99 ? '99+' : notificationsStore.unreadCount() }}
          </span>
        }
      </button>

      @if (isNotificationsOpen()) {
        <div class="notifications-popover">
          <app-notifications-dropdown
            [items]="notificationsStore.items()"
            [loading]="notificationsStore.loading()"
            [loadingMore]="notificationsStore.loadingMore()"
            [error]="notificationsStore.error()"
            [hasUnread]="notificationsStore.hasUnread()"
            [isEmpty]="notificationsStore.isEmpty()"
            [hasMore]="notificationsStore.hasMore()"
            (retry)="retryNotifications()"
            (markAllRead)="markAllNotificationsAsRead()"
            (loadMore)="notificationsStore.loadMore()"
            (openItem)="onNotificationOpen($event)"
          ></app-notifications-dropdown>
        </div>
      }
    </div>

    <div class="profile-wrap">
      <button
        type="button"
        class="profile-button"
        (click)="toggleProfile($event)"
        [attr.aria-label]="'layout.topbar.profilebuttonaria' | t : { name: profileName() }"
        [attr.aria-expanded]="isProfileOpen()"
        aria-haspopup="true"
      >
        <span class="profile-avatar" [class.profile-avatar--image]="showProfileAvatarImage()" aria-hidden="true">
          @if (showProfileAvatarImage()) {
            <img [src]="profileAvatarUrl()" alt="" (error)="onProfileAvatarError()" />
          } @else {
            {{ profileInitials() }}
          }
        </span>
        <span class="profile-identity" aria-hidden="true">
          <span class="profile-role">{{ 'layout.topbar.profilerole' | t }}</span>
          <span class="profile-name">{{ profileName() }}</span>
        </span>
        <lucide-icon name="chevron-down" [size]="13" class="control-icon" aria-hidden="true"></lucide-icon>
      </button>

      @if (isProfileOpen()) {
        <div class="profile-menu">
          <div class="profile-menu-header">
            <span
              class="profile-menu-avatar"
              [class.profile-menu-avatar--image]="showProfileAvatarImage()"
              aria-hidden="true"
            >
              @if (showProfileAvatarImage()) {
                <img [src]="profileAvatarUrl()" alt="" (error)="onProfileAvatarError()" />
              } @else {
                {{ profileInitials() }}
              }
            </span>
            <div class="profile-menu-identity">
              <strong class="profile-menu-name">{{ profileName() }}</strong>
              <span class="profile-menu-meta">{{ profileMeta() }}</span>
            </div>
          </div>

          <div class="profile-menu-divider"></div>

          <button type="button" class="profile-menu-item" (click)="goToMyData()">
            <lucide-icon name="user" [size]="16"></lucide-icon>
            <span>{{ 'layout.topbar.profile' | t }}</span>
          </button>
          <button type="button" class="profile-menu-item" (click)="logout()">
            <lucide-icon name="log-out" [size]="16"></lucide-icon>
            <span>{{ 'layout.topbar.logout' | t }}</span>
          </button>
        </div>
      }
    </div>

    <app-platform-feedback-modal [visible]="isFeedbackOpen()" (dismissed)="onFeedbackDismissed()" />
  </div>
</header>
